import { render } from "./FocusNews.vue?vue&type=template&id=40df8372"
import script from "./FocusNews.vue?vue&type=script&lang=js"
export * from "./FocusNews.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__